/** PostHog product events (v1). Names match KEH-1504 + KEH-8003 practice funnel. */
export const PRODUCT_EVENTS = {
  interview_started: 'interview_started',
  interview_completed: 'interview_completed',
  scorecard_shared: 'scorecard_shared',
  checkout_started: 'checkout_started',
  checkout_completed: 'checkout_completed',
  practice_page_viewed: 'practice_page_viewed',
  practice_wedge_start: 'practice_wedge_start',
  practice_session_started: 'practice_session_started',
  practice_scorecard_viewed: 'practice_scorecard_viewed',
  practice_signup_completed: 'practice_signup_completed',
  signup_completed: 'signup_completed',
  challenge_created: 'challenge_created',
  challenge_link_copied: 'challenge_link_copied',
  score_card_shared: 'score_card_shared',
  observability_test: 'observability_test',
};
